import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {ServerApi} from "../ServerApi";
import {IndexWord, SearchLocationType, SearchQuery} from "../models/models";
import 'react-virtualized/styles.css';
import "./WordSearchComponent.scss";

const queryString = require('query-string');



export const SearchResultComponent: React.FC<any> = () => {
	const location = useLocation();


	const [searchedWords, setSearchedWords] = useState<IndexWord[]>([]);


	useEffect(() => {
		const searchQuery = queryString.parse(location.search, {arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true}) as SearchQuery;

		const inTerm = searchQuery.searchLocationType === SearchLocationType.Term;
		const inDescription = searchQuery.searchLocationType === SearchLocationType.Description;

		ServerApi.search(searchQuery.dictionaryGroupIds ?? [], searchQuery.searchKeyword?.toString(), inTerm, inDescription, searchQuery.searchPositionType)
			.then(data => {
				setSearchedWords(data);
			});
	}, [location.search]);


	return (
		<div className="search-result">
			{searchedWords.length > 0
				?
				<>
					<h3>검색 결과</h3>

					<ul style={{paddingLeft: "20px"}}>
						{searchedWords?.map(w =>
							<li key={w.id}>
								<Link to={`/${w.id}`}
								      style={{display: "block", textDecoration: "none", color: "black", marginBottom: "10px"}}>
									{w.term}
								</Link>
							</li>
						)}
					</ul>
				</>
				:
				<>
					<h3>검색 결과가 없습니다.</h3>
				</>
			}
		</div>
	)
};